// Privacy policy page

import React from 'react'

function PrivacyPolicy() {
  return (
    <div>
      This is privacy policy page.
    </div>
  )
}

export default PrivacyPolicy
